import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumService } from '@app/shared/services/breadcrum.service';
import { PackageSubscriptionService } from '../../services/package-subscription.service';
import { RolesSharedService } from '../../services/roles-shared.service';
import { Paginator } from "primeng/paginator";
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { LikeModalServiceService } from '@app/shared/services/like-modal-service.service';
import { NickNameModalService } from '../../services/nick-name-modal.service';

@Component({
  selector: 'app-package-subscription',
  templateUrl: './package-subscription.component.html',
  styleUrls: ['./package-subscription.component.scss']
})
export class PackageSubscriptionComponent implements OnInit {
  @ViewChild("paginatorId") paginator = new Paginator();
  datalist = []
  userId = "";
  isActiveID: string;
  techDomainListData: object;
  userDetailsObject;
  userRole;
  loggedInStatus;
  noDataCheck: boolean = false;
  selectedTab: string;
  skipValue = 0;
  totalRecords = 0;
  techDomainListselected = null;
  searchString = "";
  constructor( 
    private packageSubscriptionService : PackageSubscriptionService,
    public rolesSharedService: RolesSharedService,
    private breadcrumService:BreadcrumService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private likeModalService: LikeModalServiceService,
    private nickNameModalService: NickNameModalService,
  ) { }

  ngOnInit() {
    this.isLoggedIn();
    this.userDetails();
    this.getSubPackagelist();
    this.getDomainList();

    this.techDomainListselected = window.localStorage.getItem('selectedTechDomainId') ?
      window.localStorage.getItem('selectedTechDomainId') : null;
  }

  applyFilter( event?: any) {
    const filter: any = {};
    filter.search = this.searchString;
    this.getSubPackagelist();
  }

  isLoggedIn() {
    if (this.authenticationService.isLoggedIn()) {
      this.loggedInStatus = true;
      this.getRole();
    } else {
      this.loggedInStatus = false;
    }
  }

  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }

  getDomainList() {
    this.rolesSharedService.getTechDomainsList().subscribe(data => {
      this.techDomainListData = data;
     // console.log(this.techDomainListData, 'domain');
    });
  }
  getSubPackagelist() {
    let searchKey = this.searchString;
    this.packageSubscriptionService.getSubPackagelist(this.reportsDataFilter()).subscribe((res: any) => {
      if (searchKey === this.searchString) {
        this.datalist = res.data;
        //   console.log(this.datalist, 'sub list');
        if (this.datalist["length"] === 0) {
          this.noDataCheck = true;
        } else {
          this.noDataCheck = false;
        }
      }
    });
  }
  reportsDataFilter() {
    const filter: any = {};
    filter.filter = JSON.stringify({

      include: [
        "users",
        "domains",
        { likes: "user" },
        { comments: "user" },
        { ratings: "user" }
      ]
    });
  
    filter.search = this.searchString;
    console.log(filter.search, 'filter.search');
   
    return filter;
  }
  onScrollDown() {
    if (this.paginator) {
      this.paginator.first = 0;
    }
    if (this.selectedTab === "allReports") {
      this.skipValue = this.skipValue + 9;
      if(this.totalRecords > this.skipValue) {
        this.getSubPackagelist();
      }
    }
  }


  isAccessible(id: string, title: string, amount: number) {

    this.breadcrumService.setUrl('BC3Label',title);
    if (this.loggedInStatus) {
   //   if (this.userRole === "tech-analyst") {
        this.router.navigate([`package-subscription/package-details/${id}`]);// working
    //  return `${document.location.origin}/#/package-subscription/package-data/${id}`;
      
    //  } else {
      //  this.router.navigate([`${this.userRole}/package-details/${id}`]);
    //  }
    } else if (!this.loggedInStatus) {
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }

  getHrefUrl(id: string, title: string, amount: number) {
    if (this.loggedInStatus) {
     // if (this.userRole === "tech-analyst") {
        return `${document.location.origin}/#/package-subscription/package-details/${id}`;//working
    
    //  return `${document.location.origin}/#/package-subscription/package-data/${id}`;
     /*  } else {
        return `${document.location.origin}/#/${this.userRole}/package-details/${id}`;
      } */
    } else if (!this.loggedInStatus) {
      // fix reditect login
      return `${document.location.origin}/#/signin`;
    }
  }
  routeTechAnalystProfilePage(analystId: string) {
    this.router.navigate(['analyst-profile'], { queryParams: { analystId: analystId } })
  }
  getHrefAnalystUrl(analystId: string){
   return `${document.location.origin}/#/analyst-profile?analystId=${analystId}`;
  }

  userDetails() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      this.userId = this.userDetailsObject.userId;
     // console.log('inside user details function:',this.userDetailsObject );
    }

    if (this.authenticationService.isLoggedIn()) {
      this.loggedInStatus = true;
      this.getRole();
    } else {
      this.loggedInStatus = false;
    }
  }

  openLikeModal(data) {
    if(window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null"){
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      if (this.loggedInStatus) {
        this.likeModalService.modalStatus(true, data);
      }
    }
  }

  likeClick(postData, index) {
    if (this.loggedInStatus) {
      if (this.userDetailsObject.nickName) {
      //  console.log(this.userDetailsObject, 'this.userDetailsObject');
        let likeObject;
        likeObject = {
          postId: postData.id,
          postType: "package_subscription",
          userId: this.userId
        };
        this.rolesSharedService.addLike(likeObject).subscribe(likeResponse => {
          if (likeResponse["liked"]) {
            // case when user is liked and updated in server
            postData.liked = true;
            postData.likes += 1;
          } else if (!likeResponse["liked"]) {
            // case when user is not liked and updated in server
            postData.liked = false;
            if (postData.likes != 0) {
              postData.likes -= 1;
            }
          }
        });
      } else {
        this.nickNameModalService.openNickNameModal();
        this.nickNameModalService.nickNameDataUpdatedObservable.subscribe(
          (response: any) => {
            if (response) {
              this.userDetails();
            }
          }
        );
      }
    } else {
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }
  populateComments(data) {
    console.log('data commments:', data);
    data.postType = "package_subscription";
    if (this.loggedInStatus) {
      if (this.userDetailsObject.nickName) {
        data.showComments = !data.showComments;
        this.isActiveID = data.id;
      } else {
        this.nickNameModalService.openNickNameModal();
        this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
          if (response) {
            this.userDetails();
          }
        });
      }
    } else {
      this.router.navigate(["/signin"]);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/package-subscription/package-subscription.component.ts